export default __webpack_public_path__ + "static/media/bazzle_vm_1.0fbb54a5.png";